import { useState, useEffect } from "react";
import { Button } from "@/shared/ui/button";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";
import { useCookieConsent } from "@/features/legal/hooks/useCookieConsent";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { hasConsented, savePreferences, resetPreferences } = useCookieConsent();

  useEffect(() => {
    // Show banner if user hasn't consented yet
    if (!hasConsented) {
      setShowBanner(true);
    } else {
      setShowBanner(false);
    }
  }, [hasConsented]);

  // Listen for the custom event to open cookie settings
  useEffect(() => {
    const handleOpenCookieSettings = () => {
      resetPreferences();
      setShowBanner(true);
    };

    window.addEventListener('openCookieSettings', handleOpenCookieSettings);
    return () => {
      window.removeEventListener('openCookieSettings', handleOpenCookieSettings);
    };
  }, [resetPreferences]);

  const accept = () => {
    savePreferences({
      necessary: true,
      functional: true,
      analytics: true,
      marketing: true,
      fingerprinting: true,
    });
    setShowBanner(false);
  };

  const declineAnalytics = () => {
    savePreferences({
      necessary: true,
      functional: true,
      analytics: false,
      marketing: false,
      fingerprinting: true,
    });
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-card/95 backdrop-blur-sm border-t p-4">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-center sm:text-left flex items-center gap-2">
          <Cookie className="h-4 w-4 text-primary shrink-0" />
          <span>
            We use cookies for essential functions and analytics.{" "}
            <Link to="/privacy" className="text-primary underline hover:no-underline">
              Read our Privacy Policy
            </Link>
          </span>
        </p>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" size="sm" onClick={declineAnalytics}>
            Decline Analytics
          </Button>
          <Button size="sm" onClick={accept}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
